import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';
import Ticket, { TicketAssignConfig } from './../models/Ticket';
import { omit } from 'lodash';

export function getTickets(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.TICKET_LIST,
        params: params,
        parser: ticketsDataParser,
    }).get();
}

export function getTicketDetail(id) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.TICKET_DETAIL,
        endpointParams: { id },
        parser: (data) => new Ticket(data.data),
    }).get();
}

export function updateTicket(ticket) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.TICKET_UPDATE,
    }).put(ticket.export());
}

export function getMyTickets(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.TICKET_MY_LIST,
        params: params,
        parser: data => (data.data || []).map(item => new Ticket(item)),
    }).get();
}

export function getMyTicketDetail(id) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.TICKET_MY_DETAIL,
        endpointParams: { id },
        parser: (data) => new Ticket(data.data),
    }).get();
}

export function updateMyTicket(ticket) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.TICKET_MY_UPDATE,
    }).put(ticket.export());
}

export function getTicketAssignConfigs(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.TICKET_ASSIGN_CONFIG_LIST,
        params: params,
        parser: ticketAssignConfigsDataParser,
    }).get();
}

export function getTicketAssignConfigDetail(id) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.TICKET_ASSIGN_CONFIG_DETAIL,
        endpointParams: { id },
        parser: (data) => new TicketAssignConfig(data.data),
    }).get();
}

export function createTicketAssignConfig(ticketAssignConfig) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.TICKET_ASSIGN_CONFIG_CREATE,
    }).post(ticketAssignConfig.export());
}

export function updateTicketAssignConfig(ticketAssignConfig) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.TICKET_ASSIGN_CONFIG_UPDATE,
    }).put(ticketAssignConfig.export());
}

export function deleteTicketAssignConfig(id) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.TICKET_ASSIGN_CONFIG_DELETE,
        params: { id },
    }).delete();
}


function ticketsDataParser(data = {}) {
    return {
        ...data.data,
        tickets: (data.data.result || []).map(item => new Ticket(item))
    }
}

function ticketAssignConfigsDataParser(data = {}) {
    return {
        ...data.data,
        ticketAssignConfigs: (data.data.result || []).map(item => new TicketAssignConfig(item))
    }
}
